/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileDeleteEndpointRequest
 */
export interface FileDeleteEndpointRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileDeleteEndpointRequest
     */
    input: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FileDeleteEndpointRequest
     */
    sync?: boolean;
}

export function FileDeleteEndpointRequestFromJSON(json: any): FileDeleteEndpointRequest {
    return FileDeleteEndpointRequestFromJSONTyped(json, false);
}

export function FileDeleteEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileDeleteEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
        'sync': !exists(json, 'sync') ? undefined : json['sync'],
    };
}

export function FileDeleteEndpointRequestToJSON(value?: FileDeleteEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
        'sync': value.sync,
    };
}


